module.exports = require("react-native");